import React from "react"
import styles from "./styles.scss"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import cx from "classnames"


class County extends React.Component {
  render () {
    const { name, isChecked, county, onClick } = this.props
    return (
      <div onClick={() => onClick(county)} className={cx(styles.container, { [styles.active]: isChecked })}>
      <p>{name}</p> 
      {isChecked ?
       <FontAwesomeIcon className={styles.icon} icon="circle"/>
      : <FontAwesomeIcon className={styles.icon} icon={['far', 'circle']}/>}
      </div>
    )
  }
}

export default County


// WEBPACK FOOTER //
// src/components/SearchBarWrapper/DropdownBox/County/index.jsx